import Vue from 'vue'
import VueI18n from "vue-i18n";
import pt_Br from "./pt_br"

Vue.use(VueI18n)

export default new VueI18n({
    locale: "pt-BR",
    messages : {
      "pt-BR": pt_Br
    }
  })